import { connect } from 'react-redux';
import { modalActions } from '../../reducers/modal.reducer';
import { FaTimes } from 'react-icons/fa';
var ModalHeader = function ModalHeader(_ref) {
  var title = _ref.title,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? null : _ref$onClose,
    removeModalAction = _ref.removeModalAction;
  return /*#__PURE__*/React.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-header__title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "modal-header__close",
    onClick: function onClick() {
      if (onClose) onClose();else removeModalAction();
    }
  }, /*#__PURE__*/React.createElement(FaTimes, null)));
};
var mdtp = {
  removeModalAction: modalActions.remove
};
export default connect(null, mdtp)(ModalHeader);